import { useMutation } from '@tanstack/react-query';

import {
  CreateTimelineContainerParameters,
  CreateTimelineContainerResponse,
} from '../../../../../../typings/api/skymap/rest/v0/project';
import { SkyMapAxiosServiceFactory } from '../../../../services/axios/skymap-axios-service-factory';

type Props = {
  onSuccess?: (result: CreateTimelineContainerResponse['data']) => void;
};

const useCreateProjectTimeline = (props: Props) =>
  useMutation({
    mutationFn: async (params: CreateTimelineContainerParameters) => {
      const projectService = SkyMapAxiosServiceFactory.instance.createProjectServiceV0();
      const result = await projectService.createTimelineContainer(params);
      return result.data;
    },
    retry: false,
    networkMode: 'always',
    onSuccess: props?.onSuccess,
  });

export { useCreateProjectTimeline };
